export enum ChasublePatchingType {
  BorderEmbroidery = 'border_embroidery',
  WithTrimmings = 'with_trimmings',
  SewnPatchOnly = 'sewn_patch_only',
}
